import { Table } from "antd";
import { useTranslation } from "react-i18next";
import EditButton from "../../UI/EditButton/editbutton";
import { useState } from "react";
import EditReturnInvoices from "./EditReturnenInvoices";

const ReturnInvoicesList = () => {
  const { t } = useTranslation("common");
  const [isModalOpenReturn, setIsModalOpenReturn] = useState(false);

  const columns = [
    {
      title: `${t("returned-items")}`,
      dataIndex: "returned-items",
      key: "returned-items",
      width: "8rem",
      className: "table-header",
    },
    {
      title: `${t("returned-quantity")}`,
      dataIndex: "returned-quantity",
      key: "returned-quantity",
      width: "12rem",
    },
    {
      title: `${t("total-price")}`,
      dataIndex: "total-price",
      key: "total-price",
      width: "8rem",
    },
    {
      title: `${t("tax")}`,
      dataIndex: "tax",
      key: "tax",
      width: "10rem",
    },
    {
      title: `${t("action")}`,
      key: "action",
      width: "2rem",
      align: "center" as "center",
      render: (record: any) => (
        <>
          <EditButton
            onClick={() => {
              setIsModalOpenReturn(true);
            }}
          />
        </>
      ),
    },
  ];
  const items = [
    {
      key: "1",
    },
  ];

  return (
    <>
      <Table
        scroll={{ x: 1000 }}
        columns={columns}
        dataSource={items}
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
      />
      <EditReturnInvoices
        isModalOpenReturn={isModalOpenReturn}
        setIsModalOpenReturn={setIsModalOpenReturn}
      />
    </>
  );
};

export default ReturnInvoicesList;
